<script setup lang="ts">
import { inject } from 'vue'
import PageTitle from '@/components/PageTitle.vue'
import { customElementPropsKey } from '@/types/customElementProps.types'

const templateProps = inject(customElementPropsKey)
</script>

<template>
  <form
    :action="templateProps?.loginActionUrl"
    method="post"
    novalidate
    class="my-6"
  >
    <PageTitle :title="$t('link-account.card.title')" />
    <v-alert
      type="warning"
      :text="$t('link-account.user-exists.copy')"
      class="mb-6 text-body-2"
    ></v-alert>

    <input
      type="hidden"
      name="submitAction"
      id="linkAccount"
      value="linkAccount"
    />

    <v-input>
      <v-btn block type="submit">{{ $t('link-account.link.button') }}</v-btn>
    </v-input>
  </form>
</template>
